export const Modules = {
    rewindCore: "rewind-core",
    rewindBcDelux: "rewind-bc-delux",
    zdiTimeTracking: "zdi-time-tracking",
    bcTimeTracking: "bc-time-tracking",
    orgavision: "orgavision",
    devOps:"dev-ops",
    sedotecPlm: "sedotec-plm"
}